import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import { useRegionsStore } from '@features/footer/components/LanguageSelect/mobX/context/RegionStoreProvider';
import Button from '@components/Button/Button';
import LanguageDropdown from './LanguageDropdown/LanguageDropdown';
const DynamicLanguageSideBar = dynamic(() => import('@features/footer/components/LanguageSelect/LanguageSideBar/LanguageSideBar'), {
  ssr: false
});
const LanguageSelect = () => {
  const {
    t
  } = useTranslation('layouts');
  const {
    openSidebar,
    initializeData,
    selectedLanguage,
    regions,
    currentOffer
  } = useRegionsStore();
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false);
  useEffect(() => {
    initializeData();
  }, []);
  const availableLanguages = (() => {
    if (!regions || !currentOffer || Object.keys(regions).length === 0) {
      return null;
    }
    const index = regions.findIndex(el => el.offer === currentOffer);
    if (index !== -1 && regions) {
      return regions[index].languages;
    }
    return null;
  })();
  return <div sx={styles.languageSelect}>
      {/* @ts-expect-error - React 19 compatibility issue with next/dynamic types */}
      <DynamicLanguageSideBar />
      <span sx={styles.languageSelectIcon}>
        <Icon icon="Language" size="24px" color={theme.rawColors.darkGrey700} />
      </span>
      <div sx={styles.languageSelectTextWrapper}>
        <button type="button" onClick={() => {
        setIsDropdownExpanded(false);
        openSidebar();
      }} sx={styles.languageSelectUnderlineText}>
          {t('footer.changeRegion')}
        </button>
        <span> /&nbsp;</span>
        <Button variant="iconOnly" addSx={styles.expandMoreIcon(isDropdownExpanded)} onClick={() => setIsDropdownExpanded(prev => !prev)}>
          <span sx={styles.languageSelectUnderlineText}> {` ${selectedLanguage}`}</span>
          <Icon icon="ExpandMore" size="24px" />
        </Button>
      </div>
      {availableLanguages && <div sx={styles.dropdown(isDropdownExpanded)}>
          <LanguageDropdown availableLanguages={availableLanguages} onClose={() => setIsDropdownExpanded(false)} />
        </div>}
    </div>;
};
export default LanguageSelect;